module.exports = "@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bus/bus-map/bus-map.component.css
// module id = ./src/app/components/bus/bus-map/bus-map.component.css
// module chunks = main